import { MediaCommsState } from "./mediaComms.reducer";
import { mediaCommRoomsAdapter } from "./rooms";
import type { MediaRoomTrack } from "./rooms/mediaComms.rooms.state";

const roomSelectors = mediaCommRoomsAdapter.getSelectors(
	(state: MediaCommsState) => state.mediaCommRooms,
);

export const selectAllMediaCommRooms = roomSelectors.selectAll;
export const selectMediaRoomByRoomName = roomSelectors.selectById;
export const selectRoomByName = roomSelectors.selectById;

export const selectActiveTrackByUserAccountId = (
	state: MediaCommsState,
	userAccountId: string | undefined,
): MediaRoomTrack | undefined => {
	if (!userAccountId) return undefined;
	const rooms = roomSelectors.selectAll(state);

	for (const room of rooms) {
		const track = room.tracks.find(
			(t) => t.participant.attributes?.userAccountId === userAccountId && !t.unpublishedAt,
		);
		if (track) return track;
	}
	return undefined;
};

export const selectIsRoomMutedForUserAccountId = (
	state: MediaCommsState,
	userAccountId: string | undefined,
): boolean => {
	if (!userAccountId) return false;
	const rooms = roomSelectors.selectAll(state);

	for (const room of rooms) {
		const hasActiveTrack = room.tracks.some(
			(t) => t.participant.attributes?.userAccountId === userAccountId && !t.unpublishedAt,
		);
		if (hasActiveTrack) return room.isMuted;
	}

	return false;
};

export const selectActiveTrackAndRoomNameByUserAccountId = (
	state: MediaCommsState,
	userAccountId: string | undefined,
): { track: MediaRoomTrack; roomName: string } | undefined => {
	if (!userAccountId) return undefined;
	const rooms = roomSelectors.selectAll(state);

	for (const room of rooms) {
		const track = room.tracks.find(
			(t) =>
				t.participant.attributes?.userAccountId === userAccountId &&
				!t.unpublishedAt &&
				t.isSubscribed,
		);
		if (track) return { track, roomName: room.name };
	}
	return undefined;
};
